/* import __COLOCATED_TEMPLATE__ from './cell-name.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { InboxCategory } from 'embercom/models/data/inbox/inbox-categories';
interface Args {
  admin: any;
}

interface Signature {
  Args: Args;
}

export default class CellName extends Component<Signature> {
  /**
   * The inbox category for the route parameter.
   * Used with @models to force Ember to call the route's model hook.
   */
  get inboxCategory(): InboxCategory {
    return InboxCategory.Admin;
  }

  /**
   * The admin ID for the route parameter.
   * Used with @models to force Ember to call the route's model hook.
   */
  get adminId(): string {
    return this.args.admin.id;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Dashboard::Teammates::CellName': typeof CellName;
    'inbox2/dashboard/teammates/cell-name': typeof CellName;
  }
}
